import {EmployeeVisitFigure} from "../../pages/employee-visit-report/EmployeeVisitReportFilter";
import {Opt} from "../Optional";

export const LOW_ATTENDANCE_THRESHOLD_PERCENT = 30;

export function isLowAttendance(stats: Opt<EmployeeVisitFigure>, thresholdPercent: number = LOW_ATTENDANCE_THRESHOLD_PERCENT): boolean {
    return stats != null && (!Number.isNaN(stats.percent) && stats.percent <= thresholdPercent);
}
